import { mountSlot } from './lib';
import { trace } from './log';

const marketingSlotAttributeName = 'data-x-marketing-slot';
const marketingSlotMountedAttributeName = 'data-x-marketing-slot-mounted';
const checkGranularity = 5000;

const cssSelectorSlotNotMountedYet = `[${marketingSlotAttributeName}]:not([${marketingSlotMountedAttributeName}])`;

export const findAndMountSlotsByDataAttribute = () => {
  trace('findAndMountSlotsByDataAttribute called');
  for (const node of document.querySelectorAll(cssSelectorSlotNotMountedYet)) {
    const slotId = node.getAttribute(marketingSlotAttributeName);
    mountSlot(node, { slotId });
    node.setAttribute(marketingSlotMountedAttributeName, '');
  }
};

export const startListeningToSlots = () => {
  findAndMountSlotsByDataAttribute();
  setInterval(findAndMountSlotsByDataAttribute, checkGranularity);
};
